
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component<NPSBar>({})
export default class NPSBar extends Vue {
    @Prop({ type: Number, required: true }) public nps!: number
    @Prop({ type: Number, required: true }) public min!: number
    @Prop({ type: Number, required: true }) public max!: number
    @Prop({ type: Number, required: true }) public average!: number

    public get range(): number {
        return this.max - this.min
    }

    public get middleRelative() {
        return this.average - this.min
    }

    public get middlePercent(): number {
        const value =
            this.range > 0 ? (this.middleRelative / this.range) * 100 : 50
        return Math.max(0, Math.min(100, value))
    }

    public get delta() {
        return this.nps - this.average
    }

    public get deltaPercent() {
        return this.range > 0 ? (this.delta / this.range) * 100 : 0
    }

    public get deltaWidthPercent() {
        const value = Math.abs(this.deltaPercent)
        return Math.max(0, Math.min(value, 100))
    }

    public get deltaPositionRelative() {
        let value
        if (this.deltaPercent < 0) {
            value = this.middlePercent + this.deltaPercent
        } else {
            value = this.middlePercent
        }
        return Math.max(0, Math.min(100, value))
    }

    public get npsColor() {
        if (this.nps > this.average) {
            return '#D5DEFF'
        } else {
            return '#FCC3A8'
        }
    }
}
